const slick = require('slick-carousel'); // eslint-disable-line no-unused-vars

export default function ($selector) {
    if ($selector.attr('data-fc-slick')) {
        return;
    }
    function customPaging() {
        return '<button type="button" class="story-band_slideshow__breadcrumb" data-role="none" role="button" aria-required="false" tabindex="0"></button>';
    }

    function equalizeHeights(slickObj) {
        // debugger;
        slickObj.$slider.addClass('correctHeights');
        // console.log();
        var $track = slickObj.$slideTrack;
        var $slides = $track.find('.slick-slide');

        // layout thrashing here, can't help it since we need to remove
        // min-height to have the layout recalculate the auto height of the
        // slick track
        // $slides.css('min-height', '');
        var minSlideHeight = $track.height();
        $slides.css('min-height', minSlideHeight);

    }

    // these are default settings that all of our carousels tend to use
    const slickConfig = {
        prevArrow: '<button type="button" class="slick-prev story-band__slideshow__button story-band__slideshow__button--prev"><i class="icon-arrow"></i></button>',
        nextArrow: '<button type="button" class="slick-next story-band__slideshow__button story-band__slideshow__button--next"><i class="icon-arrow"></i></button>',
        slidesToShow: 5,
        slidesToScroll: 5,
        infinite: false,
        slide: '.story-band__article',
        responsive: [
            {
                breakpoint: 1015,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: true,
                    customPaging: customPaging,
                    infinite: true,
                    arrows: false
                }
            }
        ]
    };

    $selector.on('setPosition', function (event, slickObj) {

        if (!slickObj.setPositionEventCount) {
            slickObj.setPositionEventCount = 1;
        }

        slickObj.setPositionEventCount++;

        if (slickObj.setPositionEventCount <= 3) {
            equalizeHeights(slickObj);
        }
    });
    $selector.slick(slickConfig);
    $selector.attr('data-fc-slick', true);


    if (window.innerWidth > 600) {
        $selector.one('setPosition', function (event, slickObj) {
            //
            if (slickObj.$prevArrow) {
                slickObj.$prevArrow.hide();
            }
        });
        $selector.on('afterChange', function (event, slickObj, currSlideIndex) {
            // console.log(currSlideIndex, slickObj);
            // console.log(slickObj.slideCount);
            // console.log(slickObj.options.slidesToScroll);

            if (slickObj.$prevArrow) {
                if (currSlideIndex + slickObj.options.slidesToScroll >= slickObj.slideCount) {
                    slickObj.$nextArrow.hide();
                } else {
                    slickObj.$nextArrow.show();
                }

                if (currSlideIndex === 0) {
                    slickObj.$prevArrow.hide();
                } else {
                    slickObj.$prevArrow.show();
                }
            }
        });
    }
    // $selector.on('setPosition', function (event, slick) {
    //     // debugger;
    //     if (slick.$slides.length > slick.options.slidesToShow) {
    //         // Note: don't use this.slideWidth for this.
    //         console.log(slick.options.slidesToShow)
    //         var slideWidth = $(slick.$slides[0]).width();
    //         var addValueToEach = (slideWidth / 2) / slick.options.slidesToShow;
    //         slick.$slides.width(slideWidth + addValueToEach);
    //     }
    // });

    // $selector.on('afterChange', function (event, slick, currentSlide) {
    //     // debugger;
    //     // if (slick.$slides.length > slick.options.slidesToShow) {
    //         // Note: don't use this.slideWidth for this.
    //         // console.log(`event ${event} slick ${slick}  currentSlide ${currentSlide} nextSlide ${nextSlide}`)
    //         debugger;
    //         $selector.slick('slickGoTo', currentSlide - 1 + slick.options.slidesToShow);
    //         // var slideWidth = $(slick.$slides[0]).width();
    //         // var addValueToEach = (slideWidth / 2) / slick.options.slidesToShow;
    //         // slick.$slides.width(slideWidth + addValueToEach);
    //     // }
    // });
}
